module.exports = __webpack_public_path__ + "static/gallery-7-37f4ef7f9ceccb36239260f745644ba7.jpg";